export default "__VITE_ASSET__DV8Hmn4v__"